export default "__VITE_ASSET__D4bK9t0k__"